import MindsetsJsSDK, {LoadingAction} from "mindsets-js-sdk";

export const LOADED_PERFORMANCE_CONFIGS = '[performance_configs] Loaded performance configs';
export const SET_PERFORMANCE_MENU_DISTRICT_ID = '[performance_menu] Set district Id';

export const LoadLookerDashboardConfigsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Please wait while we load your Mindsets data!')))
        .then(() => MindsetsJsSDK().API.get('performance/configs', options))
        .then(response => {
            dispatch(LoadedLookerDashboardConfigsAction(response.configs));
            dispatch(LoadingAction(false));

            return response.configs;
        });
};
export const LoadedLookerDashboardConfigsAction = payload => ({
    type: LOADED_PERFORMANCE_CONFIGS,
    payload
});
export const SetPerformanceMenuDistrictIdAction = payload => ({
    type: SET_PERFORMANCE_MENU_DISTRICT_ID,
    payload
});
